import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/StatCard";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Zap, XCircle } from "lucide-react";

const money = (n) => `$${(Number(n) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const date = (s) => (s ? new Date(s).toLocaleDateString() : "—");
const TONE = { active: "bg-emerald-100 text-emerald-800", trialing: "bg-emerald-100 text-emerald-800", past_due: "bg-amber-100 text-amber-800" };

export default function AdminDeitySubs() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/deity/subscriptions").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const cancel = async (r) => {
    if (!window.confirm(`Cancel AI Autopilot Mode for ${r.mlo_name || r.email}? Billing stops and AI calling ends.`)) return;
    try { await api.post(`/admin/deity/${r.user_id}/cancel`); toast.success("Subscription cancelled"); load(); } catch (e) { toast.error(apiError(e)); }
  };
  const active = (rows || []).filter((r) => r.active);
  return (
    <div>
      <PageHeader title="AI Autopilot Subscriptions" subtitle="Every MLO's monthly AI Autopilot Mode subscription." />
      <div className="mb-4 flex flex-wrap gap-3 text-sm" data-testid="deity-subs-summary">
        <span className="rounded-full bg-slate-100 px-3 py-1.5"><b>{active.length}</b> active</span>
        <span className="rounded-full bg-slate-100 px-3 py-1.5"><b>{money(active.reduce((s, r) => s + (r.price || 0), 0))}</b> / month</span>
      </div>
      <Card className="overflow-x-auto" data-testid="deity-subs-table">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="px-4 py-3">MLO</th><th className="px-4 py-3">Price</th><th className="px-4 py-3">Status</th><th className="hidden px-4 py-3 md:table-cell">Started</th><th className="hidden px-4 py-3 md:table-cell">Next renewal</th><th className="hidden px-4 py-3 lg:table-cell">AI calls</th><th className="px-4 py-3" /></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows && rows.length === 0 && <tr><td colSpan={7} className="p-10 text-center text-slate-400" data-testid="deity-subs-empty"><Zap className="mx-auto mb-2 h-8 w-8" />No AI Autopilot Mode subscriptions yet.</td></tr>}
            {(rows || []).map((r) => (
              <tr key={r.user_id} data-testid={`deity-sub-${r.user_id}`}>
                <td className="px-4 py-3"><div className="font-semibold text-slate-900">{r.mlo_name || "—"}</div><div className="text-xs text-slate-500">{r.email}</div></td>
                <td className="px-4 py-3">{money(r.price)}/mo</td>
                <td className="px-4 py-3"><Badge className={`border-0 capitalize ${TONE[r.status] || "bg-slate-100 text-slate-600"}`} data-testid={`deity-sub-status-${r.user_id}`}>{(r.status || "").replace("_", " ")}</Badge></td>
                <td className="hidden px-4 py-3 md:table-cell">{date(r.started_at)}</td>
                <td className="hidden px-4 py-3 md:table-cell">{r.active ? date(r.next_renewal) : "—"}</td>
                <td className="hidden px-4 py-3 lg:table-cell">{r.calls}</td>
                <td className="px-4 py-3 text-right">{r.active && <Button size="sm" variant="ghost" className="text-red-700" onClick={() => cancel(r)} data-testid={`deity-sub-cancel-${r.user_id}`}><XCircle className="mr-1 h-3.5 w-3.5" /> Cancel</Button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
